import { Outlet } from 'react-router-dom';
import Header from './Header';
import MobileNavbar from './MobileNavbar';
import Sidebar from './Sidebar';
import SearchOverlay from './SearchOverlay';
import Footer from './Footer';
import ToastContainer from './toasts/ToastContainer';
import RegisterToast from './toasts/RegisterToast';
import AuthToast from './toasts/AuthToast';
import styles from '../App.module.css';

const Layout = () => {
  return (
    <div className={styles.appLayout}>
      <Header />
      <SearchOverlay />
      <Sidebar />
      <ToastContainer>
        <RegisterToast />
        <AuthToast />
      </ToastContainer>

      <main className={styles.mainContent}>
        <Outlet />
      </main>

      <MobileNavbar />
      <Footer />
    </div>
  );
};

export default Layout;
